<div fxLayout="column"
     fxLayoutAlign="space-around center"
     class="password-reset-page">

    <div class="form-wrapper"
         fxLayout="column"
         fxLayoutAlign="space-between center">
        <img src="assets/images/full-logo.svg"
             class="login-logo"
             alt="SalesRun Logo">

        <div fxLayout="row">
            <form class="password-form"
                  [formGroup]="form"
                  novalidate>
                <div fxLayout="column"
                     fxLayoutAlign="center center">
                    <h3>{{ isSetup ? 'Setup Password' : 'Password Reset Page'}}</h3>
                </div>
                <div fxLayout="column"
                     class="username-group"
                     fxLayoutAlign="center start">
                    <p fxLayout="row">
                        <span>User: </span>
                        <span>{{ contactName }}</span>
                    </p>
                    <p fxLayout="row"
                       class="username-field">
                        <span>User Name:</span>
                        <span>{{ userName }}</span>
                    </p>
                    <p>Minimum Password Requirments:</p>
                    <ul>
                        <li>- Six (6) Characters</li>
                        <li>- One (1) Letter</li>
                        <li>- One (1) Number</li>
                        <li>- One (1) Special character</li>
                    </ul>
                </div>
                <srp-password-setup formControlName="password">
                </srp-password-setup>
                <div fxLayout="row"
                     fxLayoutAlign="center center">
                    <button mat-raised-button
                            *ngIf="!isSetup"
                            color="accent"
                            [disabled]="!this.form?.valid || loading"
                            (click)="resetPassword()">{{buttonText}}</button>
                    <button mat-raised-button
                            *ngIf="isSetup"
                            color="accent"
                            [disabled]="!this.form?.valid || loading"
                            (click)="setupPassword()">{{buttonText}}</button>
                </div>
            </form>
        </div>
    </div>
</div>